import {
    addMerchantKyc,
    getMerchantKyc,
    updateMerchantKyc,
    fetchMerchantKycById,
    getMerchantKycCount
  } from "../../services/MerchantKycServices";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const MERCHANT_KYC_LIST_INITIATED = "MERCHANT_KYC_LIST_INITIATED";
  export const MERCHANT_KYC_INITIATED = "MERCHANT_KYC_INITIATED";
  export const MERCHANT_KYC_LIST_LOADED = "MERCHANT_KYC_LIST_LOADED";
  export const MERCHANT_KYC_LOADED = "MERCHANT_KYC_LOADED";
  export const MERCHANT_KYC_FAILED = "MERCHANT_KYC_FAILED";
  export const MERCHANT_KYC_COUNT_INITIATED = "MERCHANT_KYC_COUNT_INITIATED";
  export const MERCHANT_KYC_COUNT_LOADED = "MERCHANT_KYC_COUNT_LOADED";
  export const MERCHANT_KYC_COUNT_FAILED  = "MERCHANT_KYC_COUNT_FAILED";

  
  export const loadMerchantKyc = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_KYC_LIST_INITIATED });
      getMerchantKyc(getData)
        .then((response) => {
          console.log('response', response)
          dispatch({ type: MERCHANT_KYC_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_KYC_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantKycCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_KYC_COUNT_INITIATED });
      getMerchantKycCount(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_KYC_COUNT_LOADED, payload: response.data.data[0] });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_KYC_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  export const getMerchantKycById = (id) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_KYC_INITIATED });
      return fetchMerchantKycById(id)
        .then((response) => {
          dispatch({ type: MERCHANT_KYC_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_KYC_FAILED, payload: formatError(error) });
        });
    };
  };
  
  export const saveMerchantKycAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_KYC_INITIATED });
      const apiCall = isEdit ? updateMerchantKyc(id, data) : addMerchantKyc(data);
      return apiCall
        .then((response) => {
          formatSuccess('Merchant Transaction Settings', response.data)
          if(!isEdit){
            setTimeout(()=>{
              navigate('/merchant-transaction-settings');
            },1000)
          }
          else{
            dispatch({ type: MERCHANT_KYC_LOADED, payload: response.data.data });
          }
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: MERCHANT_KYC_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: MERCHANT_KYC_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };